/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableColumn } from "../types";

export const getGridTemplateColumns = (
  columns: TableColumn[],
  hasSelection: boolean,
): string => {
  const selectionColumn = hasSelection ? "48px " : "";

  const columnTemplates = columns
    .map((col) => {
      const w = col.width;

      if (!w) return "1fr";

      if (typeof w === "string") return w;

      if (typeof w === "number") return `${w}px`;

      const { grow, min, max } = w;

      if (min && max && min === max) {
        return typeof min === "string" ? min : `${min}px`;
      }

      if (min || max) {
        const minVal = min ? (typeof min === "string" ? min : `${min}px`) : "0";
        const maxVal = max
          ? typeof max === "string"
            ? max
            : `${max}px`
          : grow
            ? `${grow}fr`
            : "1fr";
        return `minmax(${minVal}, ${maxVal})`;
      }

      return `${grow || 1}fr`;
    })
    .join(" ");

  return selectionColumn + columnTemplates;
};

export const defaultSort = (
  a: any,
  b: any,
  dir: "asc" | "desc",
  key: string,
) => {
  const aVal = a[key];
  const bVal = b[key];

  if (aVal == null && bVal == null) return 0;
  if (aVal == null) return 1;
  if (bVal == null) return -1;

  const type = typeof aVal;

  if (type === "string") {
    const result = aVal.toLowerCase().localeCompare(bVal.toLowerCase());
    return dir === "asc" ? result : -result;
  }

  if (type === "number" || type === "boolean") {
    if (aVal < bVal) return dir === "asc" ? -1 : 1;
    if (aVal > bVal) return dir === "asc" ? 1 : -1;
    return 0;
  }

  if (aVal instanceof Date && bVal instanceof Date) {
    const diff = aVal.getTime() - bVal.getTime();
    return dir === "asc" ? diff : -diff;
  }

  const aStr = String(aVal);
  const bStr = String(bVal);
  const result = aStr.localeCompare(bStr);
  return dir === "asc" ? result : -result;
};
